module.exports = __webpack_public_path__ + "static/media/tiro.a18c4f90.png";